module.exports = __webpack_public_path__ + "static/media/card_master.e1b90d3b.png";